import context_ from "../context";
import MessagesManagerVue_ from "../vue/MessagesManagerVue";
import common from "../../common";
import Vue from "vue";
import utilities_ from "../utilities";
import config_ from "../config";
import AjaxService_ from "../../services/AjaxService";
import Pooler_ from "../../core/Pooler";

declare function require(module: string): unknown;
const context = require("../context") as typeof context_;
const utilities = require("../utilities") as typeof utilities_;
const config = require("../config") as typeof config_;
// const MessagesManagerVue = require("../vue/MessagesManagerVue") as MessagesManagerVue_;
// const AjaxService = require("../../services/AjaxService") as AjaxService_;
// const Pooler = require("../../core/Pooler") as Pooler_;

//const jsUtilities = require("../../js/jsUtilities") as any;
//const jsClasses = require("../../js/jsClasses") as any;

interface IStoredMessages {
    items: common.IMessagesManagerItem[];
}

interface ISettings {
    rootId?: string;
    pooler?: Pooler_ | null;
}

class MessagesManager implements common.IWebComponent, common.IPoolable {
    private _isInit = false;
    private _vue?: MessagesManagerVue_;
    private _ajaxService?: AjaxService_;
    private _rootId?: string;
    private _storageKey?: string;

    init(s: ISettings) {
        if (this._isInit)
            return;
        this._isInit = true;

        this._rootId = s.rootId;
        this._storageKey = this._rootId + '_storage';

        if (s.pooler)
            s.pooler.registerPoolable(this);

        this.setupVue();

        return context.components.add(this);
    }

    private setupVue() {
        Vue.prototype.$initialData = {
            vueElId: this._rootId
        };

        this._vue = new MessagesManagerVue_()
            .setOnClickItemCallback((messageId, messageType, clickUrl, asBlank) => {
                this.onClickItem(messageId, messageType, clickUrl, asBlank);
            })
            .setOnClickItemLinkCallback((messageId, messageType, linkUrl, asBlank) => {
                this.onClickItemLink(messageId, messageType, linkUrl, asBlank);
            });
    }

    hasMessages() {
        return this._vue?.items && this._vue.items.length;
    }

    onPooling(args: common.IPoolerFetchArguments, info: common.IPoolerInformations) {
        const n = Math.ceil((context.pooler.messagesManagerPoolingFrequencySec / 60) * (60 / info.frequencySec));
        const mustPool = info.iteration % n === 0;

        args.messagesManagerFetchArgs = {
            doUpdate: mustPool
        };

        return mustPool;
    }

    onPoolingSuccess(responseData: common.IPoolingFetchResponseData) {
        const d = responseData.messagesManagerData || null;

        if (!d)
            return;

        this.displayMessagesWidthDelayBetweenMessages(d.messages);
        const notifications = context.components.getNotifications();
        const totalUnreadNotifications = d.totalUnreadNotifications || 0;
        var updateTotalUnreadNotifications = true;
        if (totalUnreadNotifications)
            if (notifications.refresh())
                updateTotalUnreadNotifications = false;
        if (updateTotalUnreadNotifications)
            notifications.setTotalUnread(totalUnreadNotifications);
    }

    onPoolingError(errors: common.IError[]) {
        utilities.printError("[UPA::MessagesManager::pool] Une erreur c'est produite lors de la collecte des notifications. " + utilities.errorsToString(errors));
    }

    /** 
     * Va directement au ClickUrl (sans passer par l'api)
    */
    private onClickItem(id: string, messageType?: common.MessageTypes, url?: string, asBlank?: boolean) {
        asBlank = asBlank === true;
        if (url) {
            utilities.redirect(url, asBlank);
            return;
        }
    }

    private onClickItemLink(id: string, messageType?: common.MessageTypes, apiUrl?: string, asBlank?: boolean) {

        if (!this._ajaxService)
            this._ajaxService = new AjaxService_();

        this._ajaxService.post(apiUrl, null, true, (data: common.IMessageClickResponseData) => {
            if (!data)
                return;

            if (data.url) {
                utilities.redirect(data.url, asBlank || false);
                return;
            }

            if ((data.bag?.raw as any)["decreaseTotalUnread"] === true) {
                const n = context.components.getNotifications();
                if (n)
                    n.decreaseTotalUnread();
            }
        }, (errors: any, config: any) => {
            utilities.printError("Une erreur est survenue lors de la collect de l'url aupres de l'API.");
        });
    }

    /**
     * Afficher un message a partir d'une erreur
     * @param message
     * @param immediateDisplay default is TRUE
     * @param autoClose default is FALSE
     */
    displayErrorAsMessage(error: common.IError, source?: string | null, immediateDisplay?: boolean, autoClose?: boolean) {
        immediateDisplay = immediateDisplay !== false;
        if (!error)
            throw "L'argument 'error' est requis.";

        const alt = utilities.extractAltMessageFromMacro(error.message, config_.messages.defaultTitles.error(), common.MessageTypes.error);
        const message = {
            title: alt.updatedMessageTitle,
            contentHtml: alt.updatedMessage,
            messageType: alt.updatedMessageType,
            messageSource: source || null,
            autoClose: autoClose
        } as common.IMessage;

        this.displayMessage(message, immediateDisplay);

        return this;
    }

    /**
     * Afficher un message
     * @param message
     * @param immediateDisplay
     */
    displayMessage(message: common.IMessage | null, immediateDisplay: boolean) {
        immediateDisplay = immediateDisplay === true;
        if (immediateDisplay)
            this.appendMessage(message);
        else
            this.enqueueAndStoreMessage(message);

        return this;
    }

    /**
     * Permet d'afficher les messages en fil d'attente. 
     * Depile la file d'attente en les affichant.
     * @applyDelayBetweenMessages default is FALSE
     */
    displayQueuedMessages(applyDelayBetweenMessages?: boolean) {
        applyDelayBetweenMessages = applyDelayBetweenMessages === true;

        if (!applyDelayBetweenMessages) {
            const messages = this.dequeueStoredMessages();
            for (let i = 0; i < messages.length; i++) {
                const x = messages[i];
                this.displayMessage(x, true);
            }
        } else {
            this.displayQueuedMessagesWithDelayBettweenMessages();
        }

        return this;
    }

    closeAll() {
        this._vue?.closeAll();
        return this;
    }

    closeBySource(source?: string | null) {
        this._vue?.closeBySource(source);
        return this;
    }

    private toMessage(message: common.IMessagesManagerItem) {
        return message
            ? {
                id: message.id,
                title: message.title,
                contentHtml: message.contentHtml,
                linkUrl: message.linkUrl,
                linkText: message.linkText,
                linkAsBlank: message.linkAsBlank,
                clickUrl: message.clickUrl,
                clickToolTip: message.clickToolTip,
                clickAsBlank: message.clickAsBlank,
                noCloseOnClick: message.noCloseOnClick,
                messageSource: message.messageSource,
                messageType: message.messageType,
                messageStatus: message.messageStatus,
                autoClose: !!message.durationMs
            } as common.IMessage
            : {
                id: null,
                title: null,
                contentHtml: null,
                linkUrl: null,
                linkText: null,
                linkAsBlank: null,
                clickUrl: null,
                clickToolTip: null,
                clickAsBlank: null,
                noCloseOnClick: null,
                messageSource: null,
                messageType: common.MessageTypes.unknown,
                messageStatus: common.MessageStatusTypes.unknown,
                autoClose: null
            } as common.IMessage;
    }

    private toMessagesManagerItem(message: common.IMessage | null) {
        const creationDate = new Date();//now
        var durationMs = null as number | null;
        if (message?.autoClose === true)
            durationMs = (message.messageType === common.MessageTypes.success
                ? config_.messages.shortMessageDurationSec
                : config_.messages.defaultMessageDurationSec) * 1000;

        return message
            ? {
                durationMs: durationMs,
                creationDate: creationDate,
                id: message.id || utilities.createGuid(),
                title: message.title,
                contentHtml: message.contentHtml,
                linkUrl: message.linkUrl,
                linkText: message.linkText,
                linkAsBlank: message.linkAsBlank,
                clickUrl: message.clickUrl,
                clickToolTip: message.clickToolTip,
                clickAsBlank: message.clickAsBlank,
                noCloseOnClick: message.noCloseOnClick,
                messageSource: message.messageSource,
                messageType: message.messageType,
                messageStatus: message.messageStatus
            } as common.IMessagesManagerItem
            : {
                creationDate: creationDate,
                id: utilities.createGuid(),
                title: null,
                contentHtml: null,
                linkUrl: null,
                linkText: null,
                linkAsBlank: null,
                clickUrl: null,
                clickToolTip: null,
                clickAsBlank: null,
                noCloseOnClick: null,
                messageSource: null,
                messageType: common.MessageTypes.unknown,
                messageStatus: common.MessageStatusTypes.unknown,
                durationMs: null
            } as common.IMessagesManagerItem;
    }

    private displayQueuedMessagesWithDelayBettweenMessages() {

        utilities.dequeueWithDelayBetweenItems<common.IMessage | null>(() => {
            const message = this.dequeueStoredMessage();
            return message ? this.toMessage(message) : null;
        }, m => {
            this.displayMessage(m, true);
        }, config.messages.delayMsBetweenMessagesOnDisplayQueuedMessages);
    }

    private displayMessagesWidthDelayBetweenMessages(messages: common.IMessage[]) {

        utilities.dequeueWithDelayBetweenItems<common.IMessage | null>(() => {
            const message = messages.pop();
            return message || null;
        }, m => {
            this.displayMessage(m, true);
        }, config.messages.delayMsBetweenMessagesOnDisplayQueuedMessages);
    }

    private appendMessage(message: common.IMessage | null) {

        if (!message)
            throw "L'argument 'message' est requis.";

        const item = this.toMessagesManagerItem(message);
        this._vue?.append(item);
    }

    private enqueueAndStoreMessage(message: common.IMessage | null) {
        const storedMessages = (context.storage.retrieveObj(this._storageKey) || {
            items: []
        }) as IStoredMessages;

        const m = this.toMessagesManagerItem(message);

        storedMessages.items.push(m);

        this.storeMessages(storedMessages);
    }

    private dequeueStoredMessages() {
        const messages = this.retreiveStoredMessages();

        const r = messages.items || [];

        messages.items = [];//empty list

        this.storeMessages(messages);

        return r;
    }

    private dequeueStoredMessage() {
        const messages = this.retreiveStoredMessages();

        const message = messages.items ? messages.items.pop() : null;

        this.storeMessages(messages);

        return this.isAliveStoredMessage(message) ? message : null;
    }

    private storeMessages(messages: IStoredMessages) {
        if (!messages)
            throw "L'argument 'messages' est requis.";

        context.storage.storeObj(this._storageKey, messages);
    }

    private retreiveStoredMessages() {
        const r = (context.storage.retrieveObj(this._storageKey) || {
            items: []
        }) as IStoredMessages;
        return r;
    }

    private isAliveStoredMessage(message?: common.IMessagesManagerItem | null) {
        if (!message)
            return false;

        if (!message.creationDate)
            return true;

        const max = new Date(message.creationDate);
        max.setSeconds(max.getSeconds() + (60 * config.messages.messageLiveDurationMinutes));
        const now = new Date();
        return now < max;
    }
}

export = MessagesManager;